import { Component, HostBinding, Inject, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { environment } from './../environments/environment';
import { GeneralService } from './core/services/general.service';
import { OverlayContainer } from '@angular/cdk/overlay';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MapsService } from './shared/services/maps.service';
import { firstValueFrom, Subscription } from 'rxjs';
import { ExperienceI18nService } from './core/experience/experience-i18n.service';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {

    title = 'appweboperadores';
    env = environment;
    isLoading: boolean = false;
    error: boolean = false;
    private localeSubscription?: Subscription;

    @HostBinding('class') componentCssClass: any;

    constructor(private titleService: Title,
        public overlayContainer: OverlayContainer,
        private generalService: GeneralService,
        private experienceI18n: ExperienceI18nService,
        @Inject(MAT_DATE_FORMATS) private dateFormats: any,
        private dateAdapter: DateAdapter<any>,
        @Inject(MAT_DATE_LOCALE) private locale: string,
        private mapsService: MapsService
    ) {
        // Set theme to container
        this.overlayContainer.getContainerElement().classList.add(this.env.actualTheme);
        this.componentCssClass = this.env.actualTheme;
        // Check date formats
        console.log('Date Formats:', this.dateFormats);
        console.log('Date Locale:', this.locale);
        this.dateAdapter.setLocale(this.locale);
        // this.maps.loadApi(); // Loader API Googlem Maps
    }

    async ngOnInit() {
        this.addIcons();
        this.syncAppTitle();
        this.localeSubscription = this.experienceI18n.localeChanged$.subscribe(() => this.syncAppTitle());
        // Load Google Maps API
        try {
            await this.mapsService.loadApi();
            console.log('API Google Maps loaded');
        } catch (error) {
            console.error('Error API Google Maps', error);
        }
        // // Preload SVGs for Google Maps
        try {
            await this.preloadMapIcons();
            console.log('SVGs loaded');
        } catch (error) {
            console.error('Error preload SVGs:', error);
        }
    }

    async preloadMapIcons() {
        await this.mapsService.preloadMapIcons();
        // Aquí puedes usar los íconos cargadosenter
    }

    public setTitle(newTitle: string) {
        this.titleService.setTitle(newTitle);
    }

    ngOnDestroy(): void {
        this.localeSubscription?.unsubscribe();
    }

    private syncAppTitle(): void {
        const appName = this.experienceI18n.translate(
            'common.app-name',
            undefined,
            'Web Operadores',
        );
        this.setTitle(`Simfinix - ${appName}`);
    }

    // Add icons gloabally
    addIcons() {
        this.generalService.addIcon('facebook', 'facebook.svg');
        this.generalService.addIcon('Xcircle', 'Xcircle.svg');
        this.generalService.addIcon('enter', 'enter.svg');
        this.generalService.addIcon('upArrow', 'upArrow.svg');
        this.generalService.addIcon('downArrow', 'downArrow.svg');
        this.generalService.addIcon('clockHistory', 'ClockCounterClockwise.svg');
        this.generalService.addIcon('filters', 'filters.svg');
        this.generalService.addIcon('liquidations', 'liquidations.svg');
        this.generalService.addIcon('liquidations-2', 'liquidations-2.svg');
        this.generalService.addIcon('twitter', 'twitter.svg');
        this.generalService.addIcon('linkedin', 'linkedin.svg');
        this.generalService.addIcon('whatsapp', 'whatsapp.svg');
        this.generalService.addIcon('upload', 'upload.svg');
        this.generalService.addIcon('eye-primary', 'eye-primary.svg');
        this.generalService.addIcon('whatsappLight', 'whatsapp-light.svg');
        this.generalService.addIcon('doctor', 'doctor.svg');
        this.generalService.addIcon('pdf', 'pdf.svg');
        this.generalService.addIcon('zip', 'zip.svg');
        this.generalService.addIcon('csv', 'csv.svg');
        this.generalService.addIcon('patient', 'patient.svg');
        this.generalService.addIcon('agendada', 'agendada.svg');
        this.generalService.addIcon('realizada', 'realizada.svg');
        this.generalService.addIcon('en_curso', 'en_curso.svg');
        this.generalService.addIcon('no_realizada', 'no_realizada.svg');
        this.generalService.addIcon('masculine', 'masculine.svg');
        this.generalService.addIcon('femenine', 'femenine.svg');
        this.generalService.addIcon('gender', 'gender-fluid.svg');
        this.generalService.addIcon('arrow-right-pointed', 'arrow-right.svg');
        this.generalService.addIcon('hash', 'hash.svg');
        this.generalService.addIcon('person-injured', 'user-injured-solid.svg');
        this.generalService.addIcon('user-tie', 'user-tie-solid.svg');
        this.generalService.addIcon('evolucion-medica', 'heartbeat.svg');
        this.generalService.addIcon('calendar-indicator', 'calendar.svg');

        this.generalService.addIcon('calendar-enabled-primary', 'Calendar-enabled-primary.svg');
        this.generalService.addIcon('calendar-disabled-primary', 'Calendar-disabled-primary.svg');

        this.generalService.addIcon('no-calendar-indicator', 'no-calendar.svg');
        this.generalService.addIcon('done-calendar-indicator', 'done-calendar.svg');
        this.generalService.addIcon('to-do-list-indicator', 'to-do-list.svg');
        this.generalService.addIcon('request-indicator', 'request.svg');
        this.generalService.addIcon('portfolio-indicator', 'portfolio.svg');
        this.generalService.addIcon('id', 'id.svg');
        this.generalService.addIcon('id-card', 'id-card.svg');
        this.generalService.addIcon('id-card', 'id-card.svg');
        this.generalService.addIcon('health-insurance', 'health-insurance.svg');
        this.generalService.addIcon('clients', 'clientes.svg');
        this.generalService.addIcon('doctors', 'doctors.svg');
        this.generalService.addIcon('operator', 'operator.svg');
        this.generalService.addIcon('orders', 'orders.svg');
        this.generalService.addIcon('supplies', 'supplies.svg');
        this.generalService.addIcon('supplies-2', 'supplies-2.svg');
        this.generalService.addIcon('supplies-3', 'supplies-3.svg');
        this.generalService.addIcon('practices', 'practices.svg');
        this.generalService.addIcon('practices-2', 'practices-2.svg');
        this.generalService.addIcon('supplies_fly', 'supplies_fly.svg');
        this.generalService.addIcon('categories-of-evolutions', 'categories-of-evolutions.svg');
        this.generalService.addIcon('trato', 'trato.svg');
        this.generalService.addIcon('forms', 'forms.svg');
        this.generalService.addIcon('tags', 'medical-tag.svg');
        this.generalService.addIcon('evolutions-2', 'evolutions-2.svg');
        this.generalService.addIcon('hospital', 'hospital.svg');
        this.generalService.addIcon('user', 'user.svg');
        this.generalService.addIcon('mailLight', 'mail-light.svg');
        this.generalService.addIcon('Folders', 'Folders.svg');
        this.generalService.addIcon('NoteBlank', 'NoteBlank.svg');
        this.generalService.addIcon('UsersFour', 'UsersFour.svg');

        this.generalService.addIcon('PlusCircle-enabled-white', 'PlusCircle-enabled-white.svg');
        this.generalService.addIcon('PlusCircle-enabled-primary', 'PlusCircle-enabled-primary.svg');
        this.generalService.addIcon('PlusCircle-enabled-primary-lighter', 'PlusCircle-enabled-primary-lighter.svg');
        this.generalService.addIcon('PlusCircle-disabled-primary', 'PlusCircle-disabled-primary.svg');

        this.generalService.addIcon('ArrowCircleRight', 'ArrowCircleRight.svg');
        this.generalService.addIcon('checkCircle_enable', 'checkCircle_enable.svg');
        this.generalService.addIcon('checkCircle_disabled', 'checkCircle_disabled.svg');
        this.generalService.addIcon('ArrowCircleLeft', 'ArrowCircleLeft.svg');
        this.generalService.addIcon('userNotif', 'userNotif.svg');
        this.generalService.addIcon('users', 'Users.svg');
        this.generalService.addIcon('userCircle', 'UserCircle.svg');
        this.generalService.addIcon('WarningCircle', 'WarningCircle.svg');

        this.generalService.addIcon('ListPlus-enabled-primary', 'ListPlus-enabled-primary.svg');
        this.generalService.addIcon('ListPlus-enabled-primary-lighter', 'ListPlus-enabled-primary-lighter.svg');
        this.generalService.addIcon('ListPlus-disabled-primary', 'ListPlus-disabled-primary.svg');

        this.generalService.addIcon('ListPlus-withoutPlus-enabled-primary-lighter', 'ListPlus-withoutPlus-enabled-primary-lighter.svg');

        this.generalService.addIcon('exit-icon', 'exit.svg');
        this.generalService.addIcon('exit-disabled-icon', 'exit-disabled.svg');

        this.generalService.addIcon('billing-enabled-primary', 'Billing-enabled-primary.svg');
        this.generalService.addIcon('billing-disabled-primary', 'Billing-disabled-primary.svg');

        this.generalService.addIcon('ellipseGreen', 'ellipse-green.svg');
        this.generalService.addIcon('ellipseRed', 'ellipse-red.svg');

        this.generalService.addIcon('PencilSimple-enabled-primary', 'PencilSimple-enabled-primary.svg');
        this.generalService.addIcon('PencilSimple-enabled-primary-lighter', 'PencilSimple-enabled-primary-lighter.svg');
        this.generalService.addIcon('PencilSimple-disabled', 'PencilSimple-disabled.svg');

        this.generalService.addIcon('Trash-enabled-primary', 'Trash-enabled-primary.svg');
        this.generalService.addIcon('Trash-enabled-primary-lighter', 'Trash-enabled-primary-lighter.svg');
        this.generalService.addIcon('Trash-disabled', 'Trash-disabled.svg');

        this.generalService.addIcon('authorize-disabled', 'authorize-disabled.svg');
        this.generalService.addIcon('authorize-enabled-primary', 'authorize-enabled-primary.svg');

        this.generalService.addIcon('DotsThreeVertical-enabled-primary-lighter', 'DotsThreeVertical-enabled-primary-lighter.svg');

        this.generalService.addIcon('Info-enabled-primary-lighter', 'Info-enabled-primary-lighter.svg');

        this.generalService.addIcon('SelectAll-enabled-primary-lighter', 'SelectAll-enabled-primary-lighter.svg');

        this.generalService.addIcon('Lines-gray', 'Lines-gray.svg');

        this.generalService.addIcon('Refresh-enabled-primary-lighter', 'Refresh-enabled-primary-lighter.svg');

        this.generalService.addIcon('RefreshPrice-enabled-primary', 'RefreshPrice-enabled-primary.svg');
        this.generalService.addIcon('RefreshPrice-disabled', 'RefreshPrice-disabled.svg');

        this.generalService.addIcon('Union-enabled-primary', 'Union-enabled-primary.svg');

        this.generalService.addIcon('Filter-enabled-primary', 'Filter-enabled-primary.svg');

        this.generalService.addIcon('Home-default', 'Home-default.svg');
        this.generalService.addIcon('ChartBar', 'ChartBar-default.svg');
        this.generalService.addIcon('Consolidation-default', 'Consolidation-default.svg');
        this.generalService.addIcon('Admissions-default', 'Admissions-default.svg');
        this.generalService.addIcon('Attentions-default', 'Attentions-default.svg');
        this.generalService.addIcon('Cases-default', 'Cases-default.svg');
        this.generalService.addIcon('Tasks-default', 'Tasks-default.svg');
        this.generalService.addIcon('Admissions-dashboard-default', 'Admissions-dashboard-default.svg');

        this.generalService.addIcon('Providers-schedule-default', 'Providers-schedule-default.svg');
        this.generalService.addIcon('FindProvider-enabled-primary-27x27', 'FindProvider-enabled-primary-27x27.svg');

        this.generalService.addIcon('Settings-default', 'Settings-default.svg');
        this.generalService.addIcon('Provisional-control-default', 'Provisional-control-default.svg');
        this.generalService.addIcon('UserList-default', 'UserList-default.svg');

        this.generalService.addIcon('Delete-enabled-primary-22x22', 'Delete-enabled-primary-22x22.svg');
        this.generalService.addIcon('Delete-enabled-primary-16x16', 'Delete-enabled-primary-16x16.svg');
        this.generalService.addIcon('Delete-disabled-16x16', 'Delete-disabled-16x16.svg');
        this.generalService.addIcon('Delete-disabled-22x22', 'Delete-disabled-22x22.svg');

        this.generalService.addIcon('Edit-enabled-primary-22x22', 'Edit-enabled-primary-22x22.svg');
        this.generalService.addIcon('Edit-enabled-primary-16x16', 'Edit-enabled-primary-16x16.svg');
        this.generalService.addIcon('Edit-disabled-16x16', 'Edit-disabled-16x16.svg');
        this.generalService.addIcon('Edit-disabled-22x22', 'Edit-disabled-22x22.svg');

        this.generalService.addIcon('Add-attention-enabled-primary-22x22', 'Add-attention-enabled-primary-22x22.svg');
        this.generalService.addIcon('Add-attention-disabled-22x22', 'Add-attention-disabled-22x22.svg');
        this.generalService.addIcon('Add-attention-default-22x22', 'Add-attention-default-22x22.svg');

        this.generalService.addIcon('Copy-attention-enabled-primary-16x16', 'Copy-attention-enabled-primary-16x16.svg');
        this.generalService.addIcon('Copy-attention-disabled-16x16', 'Copy-attention-disabled-16x16.svg');

        this.generalService.addIcon('Watch-16x16', 'Watch-16x16.svg');

        this.generalService.addIcon('ReplaceAgreement-enabled-primary-22x22', 'ReplaceAgreement-enabled-primary-22x22.svg');
        this.generalService.addIcon('ReplaceAgreement-enabled-primary-16x16', 'ReplaceAgreement-enabled-primary-16x16.svg');
        this.generalService.addIcon('ReplaceAgreement-disabled-16x16', 'ReplaceAgreement-disabled-16x16.svg');
        this.generalService.addIcon('ReplaceAgreement-disabled-22x22', 'ReplaceAgreement-disabled-22x22.svg');

        this.generalService.addIcon('FindProvider-Default-27x27', 'FindProvider-Default-27x27.svg')
        this.generalService.addIcon('FindProvider-enabled-primary-27x27', 'FindProvider-enabled-primary-27x27.svg')

        this.generalService.addIcon('paperclip', 'paperclip.svg');
        this.generalService.addIcon('Send-enabled-primary-22x22', 'Send-enabled-primary-22x22.svg' );
        this.generalService.addIcon('Send-disabled-22x22', 'Send-disabled-22x22.svg');
        this.generalService.addIcon('Upload-primary', 'Upload-primary.svg');
        this.generalService.addIcon('download-primary', 'download-primary.svg');
        this.generalService.addIcon('xls', 'xls.svg');
        this.generalService.addIcon('Notepad','Notepad.svg');
        this.generalService.addIcon('patient-active','patient-active.svg');
        this.generalService.addIcon('patient-inactive','patient-inactive.svg');
        this.generalService.addIcon('provider-active-address','provider-active-address.svg');
        this.generalService.addIcon('provider-active-zone','provider-active-zone.svg');
        this.generalService.addIcon('provider-inactive-address','provider-inactive-address.svg');
        this.generalService.addIcon('provider-inactive-zone','provider-inactive-zone.svg');
        this.generalService.addIcon('provider-inactive-possible-address','provider-inactive-possible-address.svg');
        this.generalService.addIcon('provider-inactive-possible-zone','provider-inactive-possible-zone.svg');
        this.generalService.addIcon('provider-inactive-cancelled-address','provider-inactive-cancelled-address.svg');
        this.generalService.addIcon('provider-inactive-cancelled-zone','provider-inactive-cancelled-zone.svg');
        this.generalService.addIcon('cluster','cluster.svg');
        this.generalService.addIcon('copy','copy.svg');
        this.generalService.addIcon('user-list','user-list.svg');
        this.generalService.addIcon('trash-circle-primary','trash-circle-primary.svg');
        this.generalService.addIcon('trash-circle-disabled','trash-circle-disabled.svg');
        this.generalService.addIcon('add-circle-primary','add-circle-primary.svg');
        this.generalService.addIcon('calendar-primary','calendar-primary.svg')
        this.generalService.addIcon('seal-check','seal-check.svg');
        this.generalService.addIcon('provider-docs-primary','provider-docs-primary.svg');
        this.generalService.addIcon('medical-insurance-green','medical-insurance-green.svg');
        this.generalService.addIcon('users-three-green','users-three-green.svg');
        this.generalService.addIcon('user-nurse-green','user-nurse-green.svg');
        this.generalService.addIcon('headset-duotone-green','headset-duotone-green.svg');
        this.generalService.addIcon('calendar-heart-green','calendar-heart-green.svg');
        this.generalService.addIcon('first-aid-kit-green','first-aid-kit-green.svg');
        this.generalService.addIcon('invoice-green','invoice-green.svg');
        this.generalService.addIcon('sort-descending-green','sort-descending-green.svg');
        this.generalService.addIcon('handshake-green','handshake-green.svg');
        this.generalService.addIcon('list-bullets-green','list-bullets-green.svg');
        this.generalService.addIcon('tag-green','tag-green.svg');
        this.generalService.addIcon('specialties-green','specialties-green.svg');
        this.generalService.addIcon('user-primary','user-primary.svg')
        this.generalService.addIcon('user-docs-primary','user-docs-primary.svg');
        this.generalService.addIcon('user-disabled','user-disabled.svg');
        this.generalService.addIcon('arrow-square-green','arrow-square-green.svg');
        this.generalService.addIcon('dot-green','dot-green.svg');
        this.generalService.addIcon('dot-grey','dot-grey.svg');
        this.generalService.addIcon('dot-red','dot-red.svg');
        this.generalService.addIcon('dot-yellow','dot-yellow.svg');
        this.generalService.addIcon('cluster-ref-primary','cluster-ref-primary.svg');
        this.generalService.addIcon('provider-zone-primary','provider-zone-primary.svg');
        this.generalService.addIcon('provider-home-primary','provider-home-primary.svg');
        this.generalService.addIcon('provider-home-black','provider-home-black.svg');
        this.generalService.addIcon('patient-home-primary','patient-home-primary.svg');
        this.generalService.addIcon('plus', 'plus.svg');
        this.generalService.addIcon('close', 'close.svg');
        this.generalService.addIcon('faders-horizontal-black', 'faders-horizontal-black.svg');
        this.generalService.addIcon('Empty-Calendar-Disabled', 'Empty-Calendar-Disabled.svg');
        this.generalService.addIcon('add-module-orange', 'add-module-orange.svg');
        this.generalService.addIcon('Edit-enabled-orange-14x14', 'Edit-enabled-orange-14x14.svg');
        this.generalService.addIcon('Copy-enabled-orange-14x14', 'Copy-enabled-orange-14x14.svg');
        this.generalService.addIcon('Delete-enabled-orange-14x14', 'Delete-enabled-orange-14x14.svg');
        this.generalService.addIcon('module-attention-scheduled', 'Module-attention-scheduled.svg');
        this.generalService.addIcon('integration-configuration', 'IntegrationCSV.svg');
        this.generalService.addIcon('ArrowLineDown', 'ArrowLineDown.svg');
        this.generalService.addIcon('ArrowLineUp', 'ArrowLineUp.svg');
        this.generalService.addIcon('ai-review', 'ai-review.svg');
        this.generalService.addIcon('ai-auditor-reply', 'ai-auditor-reply.svg');
    }
}
